import React from 'react';

// Components
import ChatIcon from '../../assets/icons/WelcomeQuestions/ChatIcon';

// Images
import Step3MobileImg from '../../assets/images/WelcomeQuestions/Step3MobileImg.png';
import WhatsProLogo from '../../assets/images/WelcomeQuestions/WhatsProLogo.png';
import Step3Img from '../../assets/images/WelcomeQuestions/Step3Img.png';

// Material Ui (hook only)
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// UI kit
import { Button, Badge } from '@/components/ui';

const Step3WelcomeQuestion = () => {

    const matches = useMediaQuery('(min-width: 900px)');
    const navigate = useNavigate();

    const handleChange = () => {
        const storeOnboarding = JSON.parse(localStorage.getItem('storeOnboarding') || null);
        if (storeOnboarding) {
            navigate('/register?platform=' + storeOnboarding.origin.toLowerCase());
        } else{
            navigate('/register');
        }
    }

    return (
        <div className="flex flex-col items-center text-center">
            <img src={ WhatsProLogo } alt="WhatsPRO" className="h-9 w-auto" />
            <p className="mt-4 flex items-center justify-center gap-1.5 text-sm font-medium text-foreground text-balance">
                <ChatIcon/> ¡Felicitaciones! Encontraste el chat perfecto para tu página web
            </p>
            <img
                src={ matches ? Step3Img : Step3MobileImg }
                alt="WhatsPRO"
                className="mx-auto mt-6 w-3/4 max-w-[220px]"
            />
            <h2 className="mt-6 text-xl font-bold tracking-[-0.01em] text-foreground">
                Creá tu cuenta y obtené
            </h2>
            <div className="mt-3">
                <Badge variant="success" size="lg" className="rounded-full border border-success-border px-4 py-1.5 text-sm font-semibold">
                    +15 DÍAS <span className="ml-1 font-bold">GRATUITOS</span>
                </Badge>
            </div>
            <Button onClick={ handleChange } className="mt-8 w-full">
                Crear mi cuenta
            </Button>
        </div>
    )
}

export default Step3WelcomeQuestion;
